import React from 'react';
import { Facebook, Instagram, Mail, Phone, PhoneCallIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { GoogleReviewsBadge } from './GoogleReviewsBadge';
export function Footer() {
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Our Services',
    href: '/services'
  }, {
    name: 'About Us',
    href: '/about'
  }, {
    name: 'Contact Us',
    href: '/contact'
  }, {
    name: 'FAQ',
    href: '/faq'
  }];
  const services = [{
    name: 'Commercial Cleaning',
    href: '/book/commercial'
  }, {
    name: 'Basic Home Cleaning',
    href: '/book/home-cleaning'
  }, {
    name: 'Spring / Deep Cleaning',
    href: '/book/deep-cleaning'
  }, {
    name: 'Move-In / Move-Out',
    href: '/book/move-in-out'
  }, {
    name: 'Post Renovation',
    href: '/book/post-renovation'
  }, {
    name: 'Airbnb / Short Term Rental',
    href: '/book/airbnb'
  }];
  return <footer className="bg-primary text-white pt-24 md:pt-32 pb-12 relative z-30 border-t border-white/10" data-id="element-95">
      <div className="container mx-auto px-6 md:px-12" data-id="element-96">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 mb-20" data-id="element-97">
          {/* Brand & Nav */}
          <div data-id="element-98">
            <h3 className="text-sm font-bold text-white/50 uppercase tracking-widest mb-6" data-id="element-99">
              Site Map
            </h3>
            <div className="flex flex-wrap items-baseline" data-id="element-100">
              {navLinks.map((link, index) => <span key={link.name} className="flex items-baseline" data-id="element-101">
                  <Link to={link.href} className="text-3xl md:text-5xl font-heading font-bold uppercase tracking-tight text-white/80 hover:text-accent transition-colors" data-id="element-102">
                    {link.name}
                  </Link>
                  {index < navLinks.length - 1 && <span className="text-3xl md:text-5xl font-heading font-bold text-white/40 mx-1" data-id="element-103">
                      /
                    </span>}
                </span>)}
            </div>
          </div>

          {/* Services */}
          <div className="flex flex-col lg:items-end" data-id="element-104">
            <h3 className="text-sm font-bold text-white/50 uppercase tracking-widest mb-6" data-id="element-105">
              Services
            </h3>
            <ul className="space-y-3 text-left lg:text-right" data-id="element-106">
              {services.map(service => <li key={service.name} data-id="element-107">
                  <Link to={service.href} className="text-lg md:text-xl font-heading font-medium uppercase tracking-wide text-white/80 hover:text-accent transition-colors" data-id="element-108">
                    {service.name}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 pt-12 border-t border-white/10" data-id="element-109">
          {/* Logo */}
          <div className="flex items-center gap-4" data-id="element-110">
            <img src="https://cdn.magicpatterns.com/uploads/jc63Wcs2z1JuqZfJSF71Nx/logo-white.png" alt="Smith & Jengs" className="h-12" data-id="element-111" />
          </div>

          {/* Contact Info */}
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12 text-sm text-white/60" data-id="element-112">
            <a href="mailto:smithsandjengs@yahoo.com" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-113">
              <Mail size={16} data-id="element-114" /> smithsandjengs@yahoo.com
            </a>
            <a href="tel:+441869601439" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-115">
              <PhoneCallIcon size={16} data-id="element-116" /> 01869 601439
            </a>
            <a href="tel:+447432285564" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-117">
              <Phone size={16} data-id="element-118" /> 07432 285564
            </a>
          </div>

          {/* Google Reviews */}
          <GoogleReviewsBadge variant="light" size="sm" data-id="element-119" />

          {/* Socials */}
          <div className="flex items-center gap-4" data-id="element-120">
            <a href="https://www.facebook.com/SmithandJengs/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-primary transition-colors" data-id="element-121">
              <Facebook size={18} data-id="element-122" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-primary transition-colors" data-id="element-123">
              <Instagram size={18} data-id="element-124" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}